export const SITE_URL = "https://esginvest.com";
export const SITE_NAME = "ESG Invest";
export const DEFAULT_OG_IMAGE_PATH = "/opengraph.jpg";
